// Resizes/compresses an uploaded image client-side and returns it as a data: URL,
// so it can be embedded directly in a clue's `prompt` and stored in the board JSON
// (avoids needing any file storage on the server).
export function fileToResizedDataUrl(file, maxDim = 900, quality = 0.82) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onerror = () => reject(new Error("Could not read the image file"));
        reader.onload = () => {
            const img = new Image();
            img.onerror = () => reject(new Error("Could not decode the image"));
            img.onload = () => {
                let { width, height } = img;
                if (width > maxDim || height > maxDim) {
                    const scale = maxDim / Math.max(width, height);
                    width = Math.round(width * scale);
                    height = Math.round(height * scale);
                }
                const canvas = document.createElement("canvas");
                canvas.width = width;
                canvas.height = height;
                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0, width, height);
                const isPng = file.type === "image/png";
                resolve(canvas.toDataURL(isPng ? "image/png" : "image/jpeg", quality));
            };
            img.src = reader.result;
        };
        reader.readAsDataURL(file);
    });
}
